import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { ref, Ref } from 'vue';
import { ToggleButtonData } from './ToggleButtonData.model';
import ToggleButton from './ToggleButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleButtonGroup',
  setup(__props) {

const toggleButtonList: Ref<Array<ToggleButtonData>> = ref([
  {
    id: 1,
    label: 'Codes',
    pressed: false,
  },
  {
    id: 2,
    label: 'Search',
    pressed: false,
  },
  {
    id: 3,
    label: 'References',
    pressed: false,
  },
  {
    id: 4,
    label: 'Resources',
    pressed: false,
  },
]);
const onButtonPressed = (pressedToggleButtonData: ToggleButtonData) => {
  toggleButtonList.value = toggleButtonList.value.map((toggleButtonData) => {
    if (toggleButtonData.id === pressedToggleButtonData.id) {
      pressedToggleButtonData.pressed = !pressedToggleButtonData.pressed;
      toggleButtonData = pressedToggleButtonData;
    }
    return toggleButtonData;
  });
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_openBlock(), _createBlock(_component_q_btn_group, {
    unelevated: "",
    "no-caps": "",
    "toggle-color": "primary"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toggleButtonList.value, (toggleButton) => {
        return (_openBlock(), _createBlock(ToggleButton, {
          key: toggleButton.id,
          toggleButton: toggleButton,
          onClick: ($event: any) => (onButtonPressed(toggleButton)),
          onButtonPressed: onButtonPressed,
          class: _normalizeClass({ 'iodine-button-pressed': toggleButton.pressed })
        }, null, 8, ["toggleButton", "onClick", "class"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})